import { render, staticRenderFns } from "./SubFolderDocumentNameEmail.vue?vue&type=template&id=83311d42&scoped=true&"
import script from "./SubFolderDocumentNameEmail.vue?vue&type=script&lang=js&"
export * from "./SubFolderDocumentNameEmail.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderDocumentNameEmail.vue?vue&type=style&index=0&id=83311d42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83311d42",
  null
  
)

export default component.exports